<div class="modal-header">
	<button type="button" class="close" data-dismiss="modal">×</button>
	<h4 class="modal-title">{{title}}</h4>
</div>
<div class="modal-body">
	<div class="row">
		<div class="col-xs-12">
			<div class="form-group">
				<p>{{{content}}}</p>
			</div>
		</div>
	</div>
</div>
<div class="modal-footer">
{{#if isSignup}}
	<button type="button" class="btn btn-white" data-dismiss="modal">{{TR "Ablehnen"}}</button>
{{/if}}
	<a class="btn btn-primary" id="js-action">
	{{#if isSignup}}{{TR "Akzeptieren"}}{{else}}{{TR "OK"}}{{/if}}
	</a>
</div>
